const navLinks = [
  { label: "Home", href: "#hero" },
  { label: "Industries", href: "#industries" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ background: "#1e1128", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/28fc6c3a-0f66-4e71-a2ed-adf2d0f7d0ce.png"
              alt="Patronum AI"
              className="object-contain mb-4"
              style={{ width: "90px", height: "90px" }}
            />
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: "rgba(255,255,255,0.5)" }}>
              Patronum AI — Intelligence That Protects and Performs. Operational AI systems for high-stakes businesses.
            </p>
            {/* Social */}
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: "ri-linkedin-fill", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-lg transition-all cursor-pointer hover:opacity-80"
                  style={{ background: "rgba(255,255,255,0.07)", color: "rgba(255,255,255,0.5)" }}
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase mb-5" style={{ color: "#a9baab" }}>
              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm transition-colors cursor-pointer hover:text-white"
                    style={{ color: "rgba(255,255,255,0.5)" }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase mb-5" style={{ color: "#a9baab" }}>
              Services
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                "Lead Capture Systems",
                "Automated Response",
                "Smart Qualification",
                "Intelligent Routing",
                "System Audits",
              ].map((svc) => (
                <li key={svc}>
                  <span className="text-sm" style={{ color: "rgba(255,255,255,0.5)" }}>{svc}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8"
          style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
          <p className="text-xs" style={{ color: "rgba(255,255,255,0.3)" }}>
            &copy; {new Date().getFullYear()} Patronum AI. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs cursor-pointer hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.3)" }}>
              Privacy Policy
            </a>
            <a href="#" className="text-xs cursor-pointer hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.3)" }}>
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
